







































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  name: 'WelcomeNotary',
  components: {
  }
})

export default class WelcomeNotary extends Vue {
  @Prop(Number) restoreCodeErrorCounter
  t (key: string) {
    return this.$t(`WelcomeNotary.${key}`)
  }

  @Watch('restoreCodeErrorCounter') restoreCodeErrorFunction () {
    this.restoreCodeError = true
  }

  restoreCode = ''
  restoreCodeError = false
}
